import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { DialogTrigger, Button, Modal, ModalOverlay, Dialog, Heading } from 'react-aria-components';
import type { MobileFilterModalProps } from '@/types/searchSide';
export const MobileFilterModal: React.FC<MobileFilterModalProps> = t0 => {
  const $ = _c(12);
  const {
    isOpen,
    onClose,
    carsCount,
    hasActiveFilters,
    onClearAll,
    children
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = nextOpen => {
      if (!nextOpen) {
        onClose();
      }
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button className="t-flex t-min-h-11 t-items-center t-space-x-2 t-whitespace-nowrap t-px-4 t-py-2 t-bg-brand-violet t-text-white t-rounded-none t-font-medium t-shadow-sm hover:t-bg-brand-violet-dark t-transition-colors pressed:t-bg-brand-violet-dark focus:t-outline-none focus:t-ring-2 focus:t-ring-brand-violet focus:t-ring-offset-2"><svg className="t-w-5 t-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg><span>Shop Your Way</span></Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== carsCount || $[4] !== children || $[5] !== hasActiveFilters || $[6] !== onClearAll) {
    t3 = <ModalOverlay className="t-fixed t-inset-0 t-z-50 t-flex t-items-end t-justify-center t-bg-black/50 lg:t-hidden" isDismissable={true}><Modal className="t-flex t-h-[92dvh] t-w-full t-flex-col t-transform t-rounded-t-xl t-bg-white t-shadow-xl t-transition-transform t-duration-300 t-ease-out entering:t-animate-in entering:t-slide-in-from-bottom exiting:t-animate-out exiting:t-slide-out-to-bottom"><Dialog className="t-flex t-flex-col t-h-full t-min-h-0 focus:t-outline-none">{t4 => {
            const {
              close
            } = t4;
            return <><div className="t-flex t-items-center t-justify-between t-px-6 t-py-4 t-border-b t-border-gray-200 t-flex-shrink-0"><Button onPress={close} className="t-flex t-items-center t-space-x-2 t-text-gray-600 hover:t-text-gray-800 t-transition-colors focus:t-outline-none focus:t-ring-2 focus:t-ring-brand-violet t-rounded-none t-p-1" aria-label="Close filter modal"><svg className="t-w-5 t-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg><span className="t-font-medium">Back</span></Button><Heading slot="title" className="t-text-lg t-font-semibold t-text-gray-900">Filters</Heading>{hasActiveFilters ? <Button onPress={onClearAll} className="t-text-brand-violet hover:t-text-brand-violet-dark t-font-medium t-transition-colors focus:t-outline-none focus:t-ring-2 focus:t-ring-brand-violet t-rounded-none t-px-2 t-py-1" aria-label="Clear all filters">Clear All</Button> : <div className="t-w-16" aria-hidden="true" />}</div><div className="t-min-h-0 t-flex-1 t-overflow-y-auto t-overscroll-contain t-px-4 t-py-4 sm:t-px-6"><div className="t-pb-6">{children}</div></div><div className="t-flex-shrink-0 t-border-t t-border-gray-200 t-bg-gray-50 t-px-4 t-py-4 t-pb-[calc(1rem+env(safe-area-inset-bottom))] sm:t-px-6"><Button onPress={close} className="t-w-full t-px-6 t-py-3 t-bg-brand-violet t-text-white t-font-semibold t-rounded-none hover:t-bg-brand-violet-dark pressed:t-bg-brand-violet-dark t-transition-colors t-shadow-sm focus:t-outline-none focus:t-ring-2 focus:t-ring-brand-violet focus:t-ring-offset-2" aria-label={`View ${carsCount} results`}>View Results ({carsCount})</Button></div></>;
          }}</Dialog></Modal></ModalOverlay>;
    $[3] = carsCount;
    $[4] = children;
    $[5] = hasActiveFilters;
    $[6] = onClearAll;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isOpen || $[9] !== t1 || $[10] !== t3) {
    t4 = <DialogTrigger isOpen={isOpen} onOpenChange={t1}>{t2}{t3}</DialogTrigger>;
    $[8] = isOpen;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};